import { translations } from 'locales/translations';
import { _t } from 'helpers/messages';

export const messages = {
  nothingToSelect: () =>
    _t(translations.components.select.nothingToSelect, 'Nothing to select'),
};
